import React from 'react';
import { Music, Utensils, Sparkles } from 'lucide-react';

const Concept = ({ eventInfo }) => {
  return (
    <section
      id="concept"
      className="relative z-10 px-6 pb-10 -mt-28 pointer-events-none md:-mt-32 md:pb-12"
    >
      <div
        className="absolute inset-x-0 top-0 h-56 pointer-events-none md:h-64"
        style={{
          background:
            'linear-gradient(to bottom, rgba(3,7,18,0) 0%, rgba(3,7,18,0) 34%, rgba(3,7,18,0.08) 50%, rgba(3,7,18,0.3) 68%, rgba(3,7,18,0.7) 86%, rgb(3,7,18) 100%)'
        }}
      />
      <div className="absolute inset-x-0 bottom-0 top-52 pointer-events-none bg-gray-950 md:top-60" />

      <div className="relative z-10 pt-48 mx-auto max-w-5xl pointer-events-auto md:pt-72">
        <div className="overflow-hidden relative p-8 rounded-2xl border bg-[hsl(var(--background))]/50 backdrop-blur-md border-[hsl(var(--border))] shadow-[0_0_0_1px_rgba(255,255,255,0.06)_inset,0_14px_50px_rgba(0,0,0,0.35)] md:p-12">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-24 -left-24 w-56 h-56 rounded-full blur-3xl bg-white/6 animate-float" />
            <div className="absolute -right-24 -bottom-24 w-56 h-56 rounded-full blur-3xl bg-white/6 animate-float-delayed" />
            <div className="absolute inset-x-0 top-0 h-px opacity-50 animate-pulse-slow" style={{ backgroundImage: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)' }} />
            <div
              className="absolute inset-0 opacity-10 mix-blend-screen animate-[spin_30s_linear_infinite]"
              style={{
                backgroundImage: 'conic-gradient(from 0deg, rgba(255,255,255,0.20) 0deg, transparent 40deg, transparent 320deg, rgba(255,255,255,0.20) 360deg)',
                WebkitMaskImage: 'radial-gradient(circle at 50% 50%, transparent 0 60%, black 78%, transparent 100%)',
                maskImage: 'radial-gradient(circle at 50% 50%, transparent 0 60%, black 78%, transparent 100%)'
              }}
            />
          </div>
          <h2 className="mb-10 text-4xl font-black tracking-tight md:text-6xl">
            QU&apos;EST CE QUE<br />CRAPULE ?
          </h2>

          <div className="grid gap-12 md:grid-cols-2 md:gap-16">
            <div>
              <p className="mb-6 text-xl leading-relaxed text-gray-300 md:text-2xl">
                {eventInfo.tagline}.
              </p>
              <p className="mb-8 text-lg leading-relaxed text-gray-400">
                {eventInfo.description}
              </p>
              <p className="text-2xl italic font-semibold text-white md:text-3xl">
                &ldquo;{eventInfo.concept}&rdquo;
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex gap-4 items-start py-3">
                <div className="flex justify-center items-center w-10 h-10 rounded-full border bg-white/10 border-white/20">
                  <Utensils size={18} className="text-white/80" />
                </div>
                <div className="flex-1">
                  <h3 className="text-base uppercase tracking-[0.3em] text-gray-400 mb-1">Cuisine</h3>
                  <p className="text-gray-300">Un menu unique inspiré par le thème de la soirée. Deux assiettes, deux ambiances.</p>
                </div>
              </div>
              <div className="w-full h-px bg-gradient-to-r from-transparent to-transparent via-white/15" />
              <div className="flex gap-4 items-start py-3">
                <div className="flex justify-center items-center w-10 h-10 rounded-full border bg-white/10 border-white/20">
                  <Music size={18} className="text-white/80" />
                </div>
                <div className="flex-1">
                  <h3 className="text-base uppercase tracking-[0.3em] text-gray-400 mb-1">Son</h3>
                  <p className="text-gray-300">Une sélection musicale qui accompagne chaque bouchée. Techno, mais pas que.</p>
                </div>
              </div>
              <div className="w-full h-px bg-gradient-to-r from-transparent to-transparent via-white/15" />
              <div className="flex gap-4 items-start py-3">
                <div className="flex justify-center items-center w-10 h-10 rounded-full border bg-white/10 border-white/20">
                  <Sparkles size={18} className="text-white/80" />
                </div>
                <div className="flex-1">
                  <h3 className="text-base uppercase tracking-[0.3em] text-gray-400 mb-1">Ambiance</h3>
                  <p className="text-gray-300">Une expérience immersive où chaque édition est unique. Jamais deux fois la même.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Concept;
